import classNames from "classnames";
import React from "react";
import { WSElement } from "../WSElement/WSElement.component";
import { WSAvatar, WSPill } from "../common";
import { WSButton } from "../core/WSButton/WSButton.component";
import { WSIcon } from "../core/WSIcon/WSIcon.component";
import { WSText } from "../core/WSText/WSText.component";
import styles from "./WSSelect.module.scss";
import { WSSelectOption } from "./types";

type Props = {
  onClick?: () => void;
  isActive?: boolean;
  mode?: "single" | "multiple";
  isSelected?: boolean;
} & WSSelectOption;

const Checkbox: React.FC<{
  checked?: boolean;
  indeterminate?: boolean;
}> = ({ checked, indeterminate }) => (
  <span
    className={classNames(
      styles.checkbox,
      checked && styles.checkboxChecked,
      indeterminate && styles.checkboxIndeterminate
    )}
    data-testid={
      indeterminate
        ? "checkbox-indeterminate"
        : checked
          ? "checkbox-checked"
          : "checkbox-unchecked"
    }
  >
    {checked && (
      <WSIcon name="check" size="XS" color="white" />
    )}
    {indeterminate && <span className={styles.checkboxDash} />}
  </span>
);

export { Checkbox };

export const Option: React.FC<Props> = ({
  onClick,
  label,
  isActive,
  icon,
  avatar,
  labels,
  pill,
  action,
  mode,
  isSelected
}) => {
  const isMultiple = mode === "multiple";

  return (
    <WSElement
      onClick={onClick}
      className={classNames(
        styles.option,
        isActive && !isMultiple && styles.active,
        isMultiple && isSelected && styles.selected,
        isMultiple && isActive && styles.active
      )}
    >
      {isMultiple && <Checkbox checked={isSelected} />}

      <WSElement className={styles.optionContent}>
        {icon ? (
          <WSIcon name={icon} size="S" color="gray600" />
        ) : avatar ? (
          <WSAvatar
            color="white"
            colorBackground="gray500"
            size="S"
            {...avatar}
          />
        ) : null}

        <WSElement className={styles.optionLabel}>
          <WSText.ParagraphSm color="gray600">{label}</WSText.ParagraphSm>
          {labels && (
            <WSText.ParagraphXs color="gray400">
              {labels?.join(" • ")}
            </WSText.ParagraphXs>
          )}
        </WSElement>

        {pill ? (
          <WSPill {...pill} />
        ) : action ? (
          <WSButton.Link onClick={action.onClick} size="S" type="button">
            {action.text}
          </WSButton.Link>
        ) : null}
      </WSElement>

      {!isMultiple && isActive && (
        <WSIcon name="check" size="S" color="blue400" />
      )}
    </WSElement>
  );
};
